import gql from "graphql-tag";
import {client} from "./client";
import {CreateEntity} from "../../schema/CreateEntity";
import {FetchResult, Mutation} from "../../types";

const getMutation = (patchObject: {[key: string]: any}): any => ({
    variables: {input: {entity: patchObject}},
    mutation: gql`${CreateEntity}`
});

export async function createEntity (entityPatchObject: {[key: string]: any}) {
    const result: FetchResult<Mutation> = await client.mutate(getMutation(entityPatchObject));
    const entity = result.data?.createEntity?.entity;
    if (!entity) {
        throw new Error('failed to create entity');
    } else {
        await client.cache.reset();
        return entity;
    }
}
